import React from 'react'
import styled from 'styled-components'
import { type TitleWithPriceProps } from '../Types'

const TitleWrapper = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
  max-width: 100%;
  overflow: hidden;
`

const Title = styled.div.attrs({
  className: 'title'
})`
  flex: auto;
  -ms-flexbox: auto;
  font-size: 13px;
  line-height: 18px;
  max-width: 100%;
  overflow: hidden;
  & span {
    font-weight: bold;
    white-space: nowrap;
  }
`

const MoreButton = styled.div`
  background-color: ${props => props.theme.button.background};
  border: 1px solid ${props => props.theme.button.border};
  border-radius: 4px;
  color: ${props => props.theme.button.color};
  font-size: 11px;
  font-weight: 900;
  height: 35px;
  line-height: 35px;
  margin-top: 10px;
  text-align: center;
  text-transform: uppercase;
  width: 99px;
  &:hover {
    color: ${props => props.theme.button.color};
    border: 1px solid ${props => props.theme.button.hover.border};
    background-color: ${props => props.theme.button.hover.background};
  }
`

export default (props: TitleWithPriceProps) => {
  const {
    className,
    price,
    title
  } = props

  return (
    <TitleWrapper className={className}>
      <Title>
        { title } za <span>{ price } Kč</span>
      </Title>
      <MoreButton>
        Zjistěte více
      </MoreButton>
    </TitleWrapper>
  )
}
